import React from 'react';
import { Button, Box } from '@mui/material';
import { Link } from 'react-router-dom';

export default function ErrorPage() {
  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      sx={{ minHeight: '100vh' }}
    >
      <Box mb={2}>
        <h3>This page could not be found</h3>
      </Box>
      <Button component={Link} variant="contained" to="/">
        Go to home
      </Button>
    </Box>
  );
}
